import { renderSearchHighlight } from "./search_text_highlighter.js"

export class ReaderSearch {
  constructor({ url, input, status, results, labels, request, titleFor, openResult, resetHighlights, renderHighlights }) {
    this.url = url
    this.input = input
    this.status = status
    this.resultsTarget = results
    this.labels = labels
    this.request = request
    this.titleFor = titleFor
    this.openResult = openResult
    this.resetHighlights = resetHighlights
    this.renderHighlights = renderHighlights
    this.records = []
    this.abortController = null
  }

  disconnect() {
    this.abortController?.abort()
  }

  async load(query, selectedResult = null) {
    const normalizedQuery = query.trim()
    if (normalizedQuery.length < 2 || normalizedQuery.length > 200) return

    this.abortController?.abort()
    this.abortController = new AbortController()
    this.records = []
    this.resetHighlights?.()
    this.resultsTarget.replaceChildren()
    this.status.textContent = this.labels.searching

    const url = new URL(this.url, window.location.origin)
    url.searchParams.set("q", normalizedQuery)
    const response = await this.request(url, { signal: this.abortController.signal })
    if (response === null) return
    if (!response) {
      this.status.textContent = this.labels.searchError
      return
    }

    this.records = response.results || []
    this.renderResults()
    this.renderHighlights?.()
    this.renderStatus(response.truncated)

    if (selectedResult) {
      const result = this.records.find((candidate) =>
        candidate.fragment_id === selectedResult.fragmentId &&
        candidate.match_offset === selectedResult.matchOffset
      )
      if (result) await this.openResult(result, { closeSidebar: false })
    }
  }

  renderResults() {
    this.resultsTarget.replaceChildren(...this.records.map((result) => {
      const button = this.resultsTarget.ownerDocument.createElement("button")
      button.type = "button"
      button.className = "reader-search-result"

      const title = this.resultsTarget.ownerDocument.createElement("strong")
      renderSearchHighlight(title, this.titleFor(result), this.input.value)
      const excerpt = this.resultsTarget.ownerDocument.createElement("span")
      renderSearchHighlight(excerpt, result.excerpt, this.input.value)
      button.append(title, excerpt)
      button.addEventListener("click", () => this.openResult(result))
      return button
    }))
  }

  renderStatus(truncated) {
    if (this.records.length === 0) {
      this.status.textContent = this.labels.noSearchResults
      return
    }

    const countLabel = this.records.length === 1
      ? this.labels.searchCountOne
      : this.labels.searchCountOther.replace("%{count}", this.records.length)
    this.status.textContent = truncated ? `${countLabel} ${this.labels.searchTruncated}` : countLabel
  }
}
